import { useContext } from "react";
import { MdArrowForward, MdMenu } from "react-icons/md";
import { AppContext } from "../App";
import logo from "../assets/small-logo.png";

export default function TopBar(props) {
  const appContext = useContext(AppContext);

  const navItems = [
    {
      label: "Home",
      item: "home",
    },
    {
      label: "About Us",
      item: "about_us",
    },
    {
      label: "Products",
      item: "products",
    },
    {
      label: "Portfolio",
      item: "gallery",
    },
  ];

  function goTo(item) {
    appContext.navTo({
      item,
    });
  }

  function isActive(item, label) {
    if (!appContext.navItem && item === "home") return true;
    return appContext.navItem === item;
  }

  return (
    <div className="TopBar">
      <div className="body">
        <div className="container topbar-inner">
          <div className="topbar-brand">
            <MdMenu
              className="topbar-menu-trigger d-lg-none"
              size={32}
              onClick={appContext.openSideBar}
            />

            <img
              src={logo}
              alt="Esmeriser"
              className="topbar-logo-img"
              onClick={() => goTo("home")}
            />
          </div>

          <nav className="DesktopMenu d-none d-lg-flex align-items-center">
            {navItems.map((navItem) => (
              <button
                type="button"
                key={navItem.label}
                className="mMenuItem topbar-menu-link"
                data-active={isActive(navItem.item, navItem.label)}
                onClick={() => goTo(navItem.item)}
              >
                <span>{navItem.label}</span>
              </button>
            ))}
          </nav>

          <button
            type="button"
            className="topbar-quote-btn"
            onClick={() => goTo("contact_us")}
          >
            <span>Contact Us</span>
            <MdArrowForward size={18} />
          </button>
        </div>
      </div>
    </div>
  );
}
